/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "mycme-client-portal-20190607141649-hostingbucket-production",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dxhu6miandtzs.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:edb90cac-eb1a-4a23-ac7c-3cef0bf13645",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_VldIDbB8K",
    "aws_user_pools_web_client_id": "7tjhli5t8t5r98r4aeect94msn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "lookersso",
            "endpoint": "https://12wel1cmw4.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
